export enum PaymentMethod {
  OnlineByCard = "OnlineByCard",
  OnlineByThePeer = "OnlineByThePeer",
  BankTransferOnline = "BankTransferOnline",
  BankTransferManual = "BankTransferManual",
  Cheque = "Cheque",
  FlutterWave = "FlutterWave",
  PartnerPromise = "PartnerPromise",
  B2bWallet = "B2bWallet",
}
